var map = {
	"./i8-ant/dark/24.png": 1862,
	"./i8-ant/dark/48.png": 1863,
	"./i8-ant/dark/480.png": 1864,
	"./i8-ant/dark/96.png": 1865,
	"./i8-ant/light/24.png": 1866,
	"./i8-ant/light/48.png": 1867,
	"./i8-ant/light/480.png": 1868,
	"./i8-ant/light/96.png": 1869,
	"./i8-bath/dark/24.png": 1870,
	"./i8-bath/dark/48.png": 1871,
	"./i8-bath/dark/480.png": 1872,
	"./i8-bath/dark/96.png": 1873,
	"./i8-bath/light/24.png": 1874,
	"./i8-bath/light/48.png": 1875,
	"./i8-bath/light/480.png": 1876,
	"./i8-bath/light/96.png": 1877,
	"./i8-bathtub/dark/24.png": 1878,
	"./i8-bathtub/dark/48.png": 1879,
	"./i8-bathtub/dark/480.png": 1880,
	"./i8-bathtub/dark/96.png": 1881,
	"./i8-bathtub/light/24.png": 1882,
	"./i8-bathtub/light/48.png": 1883,
	"./i8-bathtub/light/480.png": 1884,
	"./i8-bathtub/light/96.png": 1885,
	"./i8-birch/dark/24.png": 1886,
	"./i8-birch/dark/48.png": 1887,
	"./i8-birch/dark/480.png": 1888,
	"./i8-birch/dark/96.png": 1889,
	"./i8-birch/light/24.png": 1890,
	"./i8-birch/light/48.png": 1891,
	"./i8-birch/light/480.png": 1892,
	"./i8-birch/light/96.png": 1893,
	"./i8-bumblebee/dark/icons8-bumblebee-24.png": 1894,
	"./i8-bumblebee/dark/icons8-bumblebee-48.png": 1895,
	"./i8-bumblebee/dark/icons8-bumblebee-480.png": 1896,
	"./i8-bumblebee/dark/icons8-bumblebee-96.png": 1897,
	"./i8-bumblebee/light/24.png": 1898,
	"./i8-bumblebee/light/48.png": 1899,
	"./i8-bumblebee/light/480.png": 1900,
	"./i8-bumblebee/light/96.png": 1901,
	"./i8-bureau/dark/24.png": 1902,
	"./i8-bureau/dark/48.png": 1903,
	"./i8-bureau/dark/480.png": 1904,
	"./i8-bureau/dark/96.png": 1905,
	"./i8-bureau/light/24.png": 1906,
	"./i8-bureau/light/48.png": 1907,
	"./i8-bureau/light/480.png": 1908,
	"./i8-bureau/light/96.png": 1909,
	"./i8-caretaker/dark/24.png": 1910,
	"./i8-caretaker/dark/48.png": 1911,
	"./i8-caretaker/dark/480.png": 1912,
	"./i8-caretaker/dark/96.png": 1913,
	"./i8-caretaker/light/24.png": 1914,
	"./i8-caretaker/light/48.png": 1915,
	"./i8-caretaker/light/480.png": 1916,
	"./i8-caretaker/light/96.png": 1917,
	"./i8-carrot/dark/24.png": 1918,
	"./i8-carrot/dark/48.png": 1919,
	"./i8-carrot/dark/480.png": 1920,
	"./i8-carrot/dark/96.png": 1921,
	"./i8-carrot/light/icons8-carrot-24.png": 1922,
	"./i8-carrot/light/icons8-carrot-48.png": 1923,
	"./i8-carrot/light/icons8-carrot-480.png": 1924,
	"./i8-carrot/light/icons8-carrot-96.png": 1925,
	"./i8-caterpillar/dark/24.png": 1926,
	"./i8-caterpillar/dark/48.png": 1927,
	"./i8-caterpillar/dark/480.png": 1928,
	"./i8-caterpillar/dark/96.png": 1929,
	"./i8-caterpillar/light/24.png": 1930,
	"./i8-caterpillar/light/48.png": 1931,
	"./i8-caterpillar/light/480.png": 1932,
	"./i8-caterpillar/light/96.png": 1933,
	"./i8-certificate/dark/24.png": 1934,
	"./i8-certificate/dark/48.png": 1935,
	"./i8-certificate/dark/480.png": 1936,
	"./i8-certificate/dark/96.png": 1937,
	"./i8-certificate/light/24.png": 1938,
	"./i8-certificate/light/48.png": 1939,
	"./i8-certificate/light/480.png": 1940,
	"./i8-certificate/light/96.png": 1941,
	"./i8-chainsaw/dark/24.png": 1942,
	"./i8-chainsaw/dark/48.png": 1943,
	"./i8-chainsaw/dark/480.png": 1944,
	"./i8-chainsaw/dark/96.png": 1945,
	"./i8-chainsaw/light/24.png": 1946,
	"./i8-chainsaw/light/48.png": 1947,
	"./i8-chainsaw/light/480.png": 1948,
	"./i8-chainsaw/light/96.png": 1949,
	"./i8-compost-heap/dark/24.png": 1950,
	"./i8-compost-heap/dark/48.png": 1951,
	"./i8-compost-heap/dark/480.png": 1952,
	"./i8-compost-heap/dark/96.png": 1953,
	"./i8-compost-heap/light/24.png": 1954,
	"./i8-compost-heap/light/48.png": 1955,
	"./i8-compost-heap/light/480.png": 1956,
	"./i8-compost-heap/light/96.png": 1957,
	"./i8-construction-worker/dark/24.png": 1958,
	"./i8-construction-worker/dark/48.png": 1959,
	"./i8-construction-worker/dark/480.png": 1960,
	"./i8-construction-worker/dark/96.png": 1961,
	"./i8-construction-worker/light/24.png": 1962,
	"./i8-construction-worker/light/48.png": 1963,
	"./i8-construction-worker/light/480.png": 1964,
	"./i8-construction-worker/light/96.png": 1965,
	"./i8-construction/dark/24.png": 1966,
	"./i8-construction/dark/48.png": 1967,
	"./i8-construction/dark/480.png": 1968,
	"./i8-construction/dark/96.png": 1969,
	"./i8-construction/light/24.png": 1970,
	"./i8-construction/light/48.png": 1971,
	"./i8-construction/light/480.png": 1972,
	"./i8-construction/light/96.png": 1973,
	"./i8-depot/dark/24.png": 1974,
	"./i8-depot/dark/48.png": 1975,
	"./i8-depot/dark/480.png": 1976,
	"./i8-depot/dark/96.png": 1977,
	"./i8-depot/light/24.png": 1978,
	"./i8-depot/light/48.png": 1979,
	"./i8-depot/light/480.png": 1980,
	"./i8-depot/light/96.png": 1981,
	"./i8-design/dark/24.png": 1982,
	"./i8-design/dark/48.png": 1983,
	"./i8-design/dark/480.png": 1984,
	"./i8-design/dark/96.png": 1985,
	"./i8-design/light/24.png": 1986,
	"./i8-design/light/48.png": 1987,
	"./i8-design/light/480.png": 1988,
	"./i8-design/light/96.png": 1989,
	"./i8-digger/dark/24.png": 1990,
	"./i8-digger/dark/48.png": 1991,
	"./i8-digger/dark/480.png": 1992,
	"./i8-digger/dark/96.png": 1993,
	"./i8-digger/light/24.png": 1994,
	"./i8-digger/light/48.png": 1995,
	"./i8-digger/light/480.png": 1996,
	"./i8-digger/light/96.png": 1997,
	"./i8-drill/dark/24.png": 1998,
	"./i8-drill/dark/48.png": 1999,
	"./i8-drill/dark/480.png": 2000,
	"./i8-drill/dark/96.png": 2001,
	"./i8-drill/light/24.png": 2002,
	"./i8-drill/light/48.png": 2003,
	"./i8-drill/light/480.png": 2004,
	"./i8-drill/light/96.png": 2005,
	"./i8-duster/dark/24.png": 2006,
	"./i8-duster/dark/48.png": 2007,
	"./i8-duster/dark/480.png": 2008,
	"./i8-duster/dark/96.png": 2009,
	"./i8-duster/light/24.png": 2010,
	"./i8-duster/light/48.png": 2011,
	"./i8-duster/light/480.png": 2012,
	"./i8-duster/light/96.png": 2013,
	"./i8-evergreen/dark/24.png": 2014,
	"./i8-evergreen/dark/48.png": 2015,
	"./i8-evergreen/dark/480.png": 2016,
	"./i8-evergreen/dark/96.png": 2017,
	"./i8-evergreen/light/24.png": 2018,
	"./i8-evergreen/light/48.png": 2019,
	"./i8-evergreen/light/480.png": 2020,
	"./i8-evergreen/light/96.png": 2021,
	"./i8-exterior/dark/24.png": 2022,
	"./i8-exterior/dark/48.png": 2023,
	"./i8-exterior/dark/480.png": 2024,
	"./i8-exterior/dark/96.png": 2025,
	"./i8-exterior/light/24.png": 2026,
	"./i8-exterior/light/48.png": 2027,
	"./i8-exterior/light/480.png": 2028,
	"./i8-exterior/light/96.png": 2029,
	"./i8-fence/dark/24.png": 2030,
	"./i8-fence/dark/48.png": 2031,
	"./i8-fence/dark/480.png": 2032,
	"./i8-fence/dark/96.png": 2033,
	"./i8-fence/light/24.png": 2034,
	"./i8-fence/light/48.png": 2035,
	"./i8-fence/light/480.png": 2036,
	"./i8-fence/light/96.png": 2037,
	"./i8-field/dark/24.png": 2038,
	"./i8-field/dark/48.png": 2039,
	"./i8-field/dark/480.png": 2040,
	"./i8-field/dark/96.png": 2041,
	"./i8-field/light/24.png": 2042,
	"./i8-field/light/48.png": 2043,
	"./i8-field/light/480.png": 2044,
	"./i8-field/light/96.png": 2045,
	"./i8-floor-plan/dark/24.png": 2046,
	"./i8-floor-plan/dark/48.png": 2047,
	"./i8-floor-plan/dark/480.png": 2048,
	"./i8-floor-plan/dark/96.png": 2049,
	"./i8-floor-plan/light/24.png": 2050,
	"./i8-floor-plan/light/48.png": 2051,
	"./i8-floor-plan/light/480.png": 2052,
	"./i8-floor-plan/light/96.png": 2053,
	"./i8-flower-bouquet/dark/24.png": 2054,
	"./i8-flower-bouquet/dark/48.png": 2055,
	"./i8-flower-bouquet/dark/480.png": 2056,
	"./i8-flower-bouquet/dark/96.png": 2057,
	"./i8-flower-bouquet/light/24.png": 2058,
	"./i8-flower-bouquet/light/48.png": 2059,
	"./i8-flower-bouquet/light/480.png": 2060,
	"./i8-flower-bouquet/light/96.png": 2061,
	"./i8-flowers/dark/24.png": 2062,
	"./i8-flowers/dark/48.png": 2063,
	"./i8-flowers/dark/480.png": 2064,
	"./i8-flowers/dark/96.png": 2065,
	"./i8-flowers/light/24.png": 2066,
	"./i8-flowers/light/48.png": 2067,
	"./i8-flowers/light/480.png": 2068,
	"./i8-flowers/light/96.png": 2069,
	"./i8-fly/dark/24.png": 2070,
	"./i8-fly/dark/48.png": 2071,
	"./i8-fly/dark/480.png": 2072,
	"./i8-fly/dark/96.png": 2073,
	"./i8-fly/light/24.png": 2074,
	"./i8-fly/light/48.png": 2075,
	"./i8-fly/light/480.png": 2076,
	"./i8-fly/light/96.png": 2077,
	"./i8-forest/dark/24.png": 2078,
	"./i8-forest/dark/48.png": 2079,
	"./i8-forest/dark/480.png": 2080,
	"./i8-forest/dark/96.png": 2081,
	"./i8-forest/light/24.png": 2082,
	"./i8-forest/light/48.png": 2083,
	"./i8-forest/light/480.png": 2084,
	"./i8-forest/light/96.png": 2085,
	"./i8-fountain/dark/24.png": 2086,
	"./i8-fountain/dark/48.png": 2087,
	"./i8-fountain/dark/480.png": 2088,
	"./i8-fountain/dark/96.png": 2089,
	"./i8-fountain/light/24.png": 2090,
	"./i8-fountain/light/48.png": 2091,
	"./i8-fountain/light/480.png": 2092,
	"./i8-fountain/light/96.png": 2093,
	"./i8-garbage-truck/dark/24.png": 2094,
	"./i8-garbage-truck/dark/48.png": 2095,
	"./i8-garbage-truck/dark/480.png": 2096,
	"./i8-garbage-truck/dark/96.png": 2097,
	"./i8-garbage-truck/light/24.png": 2098,
	"./i8-garbage-truck/light/48.png": 2099,
	"./i8-garbage-truck/light/480.png": 2100,
	"./i8-garbage-truck/light/96.png": 2101,
	"./i8-garden-gloves/dark/24.png": 2102,
	"./i8-garden-gloves/dark/48.png": 2103,
	"./i8-garden-gloves/dark/480.png": 2104,
	"./i8-garden-gloves/dark/96.png": 2105,
	"./i8-garden-gloves/light/24.png": 2106,
	"./i8-garden-gloves/light/48.png": 2107,
	"./i8-garden-gloves/light/480.png": 2108,
	"./i8-garden-gloves/light/96.png": 2109,
	"./i8-garden-shears/dark/24.png": 2110,
	"./i8-garden-shears/dark/48.png": 2111,
	"./i8-garden-shears/dark/480.png": 2112,
	"./i8-garden-shears/dark/96.png": 2113,
	"./i8-garden-shears/light/24.png": 2114,
	"./i8-garden-shears/light/48.png": 2115,
	"./i8-garden-shears/light/480.png": 2116,
	"./i8-garden-shears/light/96.png": 2117,
	"./i8-grass/dark/24.png": 2118,
	"./i8-grass/dark/48.png": 2119,
	"./i8-grass/dark/480.png": 2120,
	"./i8-grass/dark/96.png": 2121,
	"./i8-grass/light/24.png": 2122,
	"./i8-grass/light/48.png": 2123,
	"./i8-grass/light/480.png": 2124,
	"./i8-grass/light/96.png": 2125,
	"./i8-hammer/dark/24.png": 2126,
	"./i8-hammer/dark/48.png": 2127,
	"./i8-hammer/dark/480.png": 2128,
	"./i8-hammer/dark/96.png": 2129,
	"./i8-hammer/light/24.png": 2130,
	"./i8-hammer/light/48.png": 2131,
	"./i8-hammer/light/480.png": 2132,
	"./i8-hammer/light/96.png": 2133,
	"./i8-harness/dark/24.png": 2134,
	"./i8-harness/dark/48.png": 2135,
	"./i8-harness/dark/480.png": 2136,
	"./i8-harness/dark/96.png": 2137,
	"./i8-harness/light/24.png": 2138,
	"./i8-harness/light/48.png": 2139,
	"./i8-harness/light/480.png": 2140,
	"./i8-harness/light/96.png": 2141,
	"./i8-hive/dark/24.png": 2142,
	"./i8-hive/dark/48.png": 2143,
	"./i8-hive/dark/480.png": 2144,
	"./i8-hive/dark/96.png": 2145,
	"./i8-hive/light/24.png": 2146,
	"./i8-hive/light/48.png": 2147,
	"./i8-hive/light/480.png": 2148,
	"./i8-hive/light/96.png": 2149,
	"./i8-home/dark/24.png": 2150,
	"./i8-home/dark/48.png": 2151,
	"./i8-home/dark/480.png": 2152,
	"./i8-home/dark/96.png": 2153,
	"./i8-home/light/24.png": 2154,
	"./i8-home/light/48.png": 2155,
	"./i8-home/light/480.png": 2156,
	"./i8-home/light/96.png": 2157,
	"./i8-house/dark/24.png": 2158,
	"./i8-house/dark/48.png": 2159,
	"./i8-house/dark/480.png": 2160,
	"./i8-house/dark/96.png": 2161,
	"./i8-house/light/24.png": 2162,
	"./i8-house/light/48.png": 2163,
	"./i8-house/light/480.png": 2164,
	"./i8-house/light/96.png": 2165,
	"./i8-housekeeper/dark/24.png": 2166,
	"./i8-housekeeper/dark/48.png": 2167,
	"./i8-housekeeper/dark/480.png": 2168,
	"./i8-housekeeper/dark/96.png": 2169,
	"./i8-housekeeper/light/24.png": 2170,
	"./i8-housekeeper/light/48.png": 2171,
	"./i8-housekeeper/light/480.png": 2172,
	"./i8-housekeeper/light/96.png": 2173,
	"./i8-housekeeping/dark/24.png": 2174,
	"./i8-housekeeping/dark/48.png": 2175,
	"./i8-housekeeping/dark/480.png": 2176,
	"./i8-housekeeping/dark/96.png": 2177,
	"./i8-housekeeping/light/24.png": 2178,
	"./i8-housekeeping/light/48.png": 2179,
	"./i8-housekeeping/light/480.png": 2180,
	"./i8-housekeeping/light/96.png": 2181,
	"./i8-insect/dark/24.png": 2182,
	"./i8-insect/dark/48.png": 2183,
	"./i8-insect/dark/480.png": 2184,
	"./i8-insect/dark/96.png": 2185,
	"./i8-insect/light/24.png": 2186,
	"./i8-insect/light/48.png": 2187,
	"./i8-insect/light/480.png": 2188,
	"./i8-insect/light/96.png": 2189,
	"./i8-insecticide/dark/24.png": 2190,
	"./i8-insecticide/dark/48.png": 2191,
	"./i8-insecticide/dark/480.png": 2192,
	"./i8-insecticide/dark/96.png": 2193,
	"./i8-insecticide/light/24.png": 2194,
	"./i8-insecticide/light/48.png": 2195,
	"./i8-insecticide/light/480.png": 2196,
	"./i8-insecticide/light/96.png": 2197,
	"./i8-interior/dark/24.png": 2198,
	"./i8-interior/dark/48.png": 2199,
	"./i8-interior/dark/480.png": 2200,
	"./i8-interior/dark/96.png": 2201,
	"./i8-interior/light/24.png": 2202,
	"./i8-interior/light/48.png": 2203,
	"./i8-interior/light/480.png": 2204,
	"./i8-interior/light/96.png": 2205,
	"./i8-irrigation/dark/24.png": 2206,
	"./i8-irrigation/dark/48.png": 2207,
	"./i8-irrigation/dark/480.png": 2208,
	"./i8-irrigation/dark/96.png": 2209,
	"./i8-irrigation/light/24.png": 2210,
	"./i8-irrigation/light/48.png": 2211,
	"./i8-irrigation/light/480.png": 2212,
	"./i8-irrigation/light/96.png": 2213,
	"./i8-land-surveying/dark/24.png": 2214,
	"./i8-land-surveying/dark/48.png": 2215,
	"./i8-land-surveying/dark/480.png": 2216,
	"./i8-land-surveying/dark/96.png": 2217,
	"./i8-land-surveying/light/24.png": 2218,
	"./i8-land-surveying/light/48.png": 2219,
	"./i8-land-surveying/light/480.png": 2220,
	"./i8-land-surveying/light/96.png": 2221,
	"./i8-lawn-mower/dark/24.png": 2222,
	"./i8-lawn-mower/dark/48.png": 2223,
	"./i8-lawn-mower/dark/96.png": 2224,
	"./i8-lawn-mower/light/24.png": 2225,
	"./i8-lawn-mower/light/48.png": 2226,
	"./i8-lawn-mower/light/96.png": 2227,
	"./i8-leaf/dark/24.png": 2228,
	"./i8-leaf/dark/48.png": 2229,
	"./i8-leaf/dark/480.png": 2230,
	"./i8-leaf/dark/96.png": 2231,
	"./i8-leaf/light/24.png": 2232,
	"./i8-leaf/light/48.png": 2233,
	"./i8-leaf/light/480.png": 2234,
	"./i8-leaf/light/96.png": 2235,
	"./i8-measurement-tool/dark/24.png": 2236,
	"./i8-measurement-tool/dark/48.png": 2237,
	"./i8-measurement-tool/dark/480.png": 2238,
	"./i8-measurement-tool/dark/96.png": 2239,
	"./i8-measurement-tool/light/24.png": 2240,
	"./i8-measurement-tool/light/48.png": 2241,
	"./i8-measurement-tool/light/480.png": 2242,
	"./i8-measurement-tool/light/96.png": 2243,
	"./i8-metal/dark/24.png": 2244,
	"./i8-metal/dark/48.png": 2245,
	"./i8-metal/dark/480.png": 2246,
	"./i8-metal/dark/96.png": 2247,
	"./i8-metal/light/24.png": 2248,
	"./i8-metal/light/48.png": 2249,
	"./i8-metal/light/480.png": 2250,
	"./i8-metal/light/96.png": 2251,
	"./i8-move-shit-around/dark/24.png": 2252,
	"./i8-move-shit-around/dark/48.png": 2253,
	"./i8-move-shit-around/dark/480.png": 2254,
	"./i8-move-shit-around/dark/96.png": 2255,
	"./i8-move-shit-around/light/24.png": 2256,
	"./i8-move-shit-around/light/48.png": 2257,
	"./i8-move-shit-around/light/480.png": 2258,
	"./i8-move-shit-around/light/96.png": 2259,
	"./i8-natural-food/dark/24.png": 2260,
	"./i8-natural-food/dark/48.png": 2261,
	"./i8-natural-food/dark/480.png": 2262,
	"./i8-natural-food/dark/96.png": 2263,
	"./i8-natural-food/light/24.png": 2264,
	"./i8-natural-food/light/48.png": 2265,
	"./i8-natural-food/light/480.png": 2266,
	"./i8-natural-food/light/96.png": 2267,
	"./i8-oak-leaf/dark/24.png": 2268,
	"./i8-oak-leaf/dark/48.png": 2269,
	"./i8-oak-leaf/dark/480.png": 2270,
	"./i8-oak-leaf/dark/96.png": 2271,
	"./i8-oak-leaf/light/24.png": 2272,
	"./i8-oak-leaf/light/48.png": 2273,
	"./i8-oak-leaf/light/480.png": 2274,
	"./i8-oak-leaf/light/96.png": 2275,
	"./i8-oak-tree/dark/24.png": 2276,
	"./i8-oak-tree/dark/48.png": 2277,
	"./i8-oak-tree/dark/480.png": 2278,
	"./i8-oak-tree/dark/96.png": 2279,
	"./i8-oak-tree/light/24.png": 2280,
	"./i8-oak-tree/light/48.png": 2281,
	"./i8-oak-tree/light/480.png": 2282,
	"./i8-oak-tree/light/96.png": 2283,
	"./i8-open-window/dark/24.png": 2284,
	"./i8-open-window/dark/48.png": 2285,
	"./i8-open-window/dark/480.png": 2286,
	"./i8-open-window/dark/96.png": 2287,
	"./i8-open-window/light/24.png": 2288,
	"./i8-open-window/light/48.png": 2289,
	"./i8-open-window/light/480.png": 2290,
	"./i8-open-window/light/96.png": 2291,
	"./i8-paint-brush/dark/24.png": 2292,
	"./i8-paint-brush/dark/48.png": 2293,
	"./i8-paint-brush/dark/480.png": 2294,
	"./i8-paint-brush/dark/96.png": 2295,
	"./i8-paint-brush/light/24.png": 2296,
	"./i8-paint-brush/light/48.png": 2297,
	"./i8-paint-brush/light/480.png": 2298,
	"./i8-paint-brush/light/96.png": 2299,
	"./i8-paint-bucket/dark/24.png": 2300,
	"./i8-paint-bucket/dark/48.png": 2301,
	"./i8-paint-bucket/dark/480.png": 2302,
	"./i8-paint-bucket/dark/96.png": 2303,
	"./i8-paint-bucket/light/24.png": 2304,
	"./i8-paint-bucket/light/48.png": 2305,
	"./i8-paint-bucket/light/480.png": 2306,
	"./i8-paint-bucket/light/96.png": 2307,
	"./i8-paint-roller/dark/24.png": 2308,
	"./i8-paint-roller/dark/48.png": 2309,
	"./i8-paint-roller/dark/480.png": 2310,
	"./i8-paint-roller/dark/96.png": 2311,
	"./i8-paint-roller/light/24.png": 2312,
	"./i8-paint-roller/light/48.png": 2313,
	"./i8-paint-roller/light/480.png": 2314,
	"./i8-paint-roller/light/96.png": 2315,
	"./i8-paint-sprayer/dark/24.png": 2316,
	"./i8-paint-sprayer/dark/48.png": 2317,
	"./i8-paint-sprayer/dark/480.png": 2318,
	"./i8-paint-sprayer/dark/96.png": 2319,
	"./i8-paint-sprayer/light/24.png": 2320,
	"./i8-paint-sprayer/light/48.png": 2321,
	"./i8-paint-sprayer/light/480.png": 2322,
	"./i8-paint-sprayer/light/96.png": 2323,
	"./i8-physical-therapy/dark/24.png": 2324,
	"./i8-physical-therapy/dark/48.png": 2325,
	"./i8-physical-therapy/dark/480.png": 2326,
	"./i8-physical-therapy/dark/96.png": 2327,
	"./i8-physical-therapy/light/24.png": 2328,
	"./i8-physical-therapy/light/48.png": 2329,
	"./i8-physical-therapy/light/480.png": 2330,
	"./i8-physical-therapy/light/96.png": 2331,
	"./i8-piping/dark/24.png": 2332,
	"./i8-piping/dark/48.png": 2333,
	"./i8-piping/dark/480.png": 2334,
	"./i8-piping/dark/96.png": 2335,
	"./i8-piping/light/24.png": 2336,
	"./i8-piping/light/48.png": 2337,
	"./i8-piping/light/480.png": 2338,
	"./i8-piping/light/96.png": 2339,
	"./i8-pitchfork/dark/24.png": 2340,
	"./i8-pitchfork/dark/48.png": 2341,
	"./i8-pitchfork/dark/480.png": 2342,
	"./i8-pitchfork/dark/96.png": 2343,
	"./i8-pitchfork/light/24.png": 2344,
	"./i8-pitchfork/light/48.png": 2345,
	"./i8-pitchfork/light/480.png": 2346,
	"./i8-pitchfork/light/96.png": 2347,
	"./i8-pliers/dark/24.png": 2348,
	"./i8-pliers/dark/48.png": 2349,
	"./i8-pliers/dark/480.png": 2350,
	"./i8-pliers/dark/96.png": 2351,
	"./i8-pliers/light/24.png": 2352,
	"./i8-pliers/light/48.png": 2353,
	"./i8-pliers/light/480.png": 2354,
	"./i8-pliers/light/96.png": 2355,
	"./i8-plumbing/dark/24.png": 2356,
	"./i8-plumbing/dark/48.png": 2357,
	"./i8-plumbing/dark/480.png": 2358,
	"./i8-plumbing/dark/96.png": 2359,
	"./i8-plumbing/light/24.png": 2360,
	"./i8-plumbing/light/48.png": 2361,
	"./i8-plumbing/light/480.png": 2362,
	"./i8-plumbing/light/96.png": 2363,
	"./i8-potted-plant/dark/24.png": 2364,
	"./i8-potted-plant/dark/48.png": 2365,
	"./i8-potted-plant/dark/480.png": 2366,
	"./i8-potted-plant/dark/96.png": 2367,
	"./i8-potted-plant/light/24.png": 2368,
	"./i8-potted-plant/light/48.png": 2369,
	"./i8-potted-plant/light/480.png": 2370,
	"./i8-potted-plant/light/96.png": 2371,
	"./i8-rock/dark/24.png": 2372,
	"./i8-rock/dark/48.png": 2373,
	"./i8-rock/dark/480.png": 2374,
	"./i8-rock/dark/96.png": 2375,
	"./i8-rock/light/24.png": 2376,
	"./i8-rock/light/48.png": 2377,
	"./i8-rock/light/480.png": 2378,
	"./i8-rock/light/96.png": 2379,
	"./i8-roofing/dark/24.png": 2380,
	"./i8-roofing/dark/48.png": 2381,
	"./i8-roofing/dark/480.png": 2382,
	"./i8-roofing/dark/96.png": 2383,
	"./i8-roofing/light/24.png": 2384,
	"./i8-roofing/light/48.png": 2385,
	"./i8-roofing/light/480.png": 2386,
	"./i8-roofing/light/96.png": 2387,
	"./i8-room/dark/24.png": 2388,
	"./i8-room/dark/48.png": 2389,
	"./i8-room/dark/480.png": 2390,
	"./i8-room/dark/96.png": 2391,
	"./i8-room/light/24.png": 2392,
	"./i8-room/light/48.png": 2393,
	"./i8-room/light/480.png": 2394,
	"./i8-room/light/96.png": 2395,
	"./i8-saw/dark/24.png": 2396,
	"./i8-saw/dark/48.png": 2397,
	"./i8-saw/dark/480.png": 2398,
	"./i8-saw/dark/96.png": 2399,
	"./i8-saw/light/24.png": 2400,
	"./i8-saw/light/48.png": 2401,
	"./i8-saw/light/480.png": 2402,
	"./i8-saw/light/96.png": 2403,
	"./i8-screwdriver/dark/24.png": 2404,
	"./i8-screwdriver/dark/48.png": 2405,
	"./i8-screwdriver/dark/480.png": 2406,
	"./i8-screwdriver/dark/96.png": 2407,
	"./i8-screwdriver/light/24.png": 2408,
	"./i8-screwdriver/light/48.png": 2409,
	"./i8-screwdriver/light/480.png": 2410,
	"./i8-screwdriver/light/96.png": 2411,
	"./i8-seed/dark/24.png": 2412,
	"./i8-seed/dark/48.png": 2413,
	"./i8-seed/dark/480.png": 2414,
	"./i8-seed/dark/96.png": 2415,
	"./i8-seed/light/24.png": 2416,
	"./i8-seed/light/48.png": 2417,
	"./i8-seed/light/480.png": 2418,
	"./i8-seed/light/96.png": 2419,
	"./i8-sliding-door-closet/dark/24.png": 2420,
	"./i8-sliding-door-closet/dark/48.png": 2421,
	"./i8-sliding-door-closet/dark/480.png": 2422,
	"./i8-sliding-door-closet/dark/96.png": 2423,
	"./i8-sliding-door-closet/light/24.png": 2424,
	"./i8-sliding-door-closet/light/48.png": 2425,
	"./i8-sliding-door-closet/light/480.png": 2426,
	"./i8-sliding-door-closet/light/96.png": 2427,
	"./i8-slug-eating/dark/24.png": 2428,
	"./i8-slug-eating/dark/48.png": 2429,
	"./i8-slug-eating/dark/480.png": 2430,
	"./i8-slug-eating/dark/96.png": 2431,
	"./i8-slug-eating/light/24.png": 2432,
	"./i8-slug-eating/light/48.png": 2433,
	"./i8-slug-eating/light/480.png": 2434,
	"./i8-slug-eating/light/96.png": 2435,
	"./i8-slug/dark/24.png": 2436,
	"./i8-slug/dark/48.png": 2437,
	"./i8-slug/dark/480.png": 2438,
	"./i8-slug/dark/96.png": 2439,
	"./i8-slug/light/24.png": 2440,
	"./i8-slug/light/48.png": 2441,
	"./i8-slug/light/480.png": 2442,
	"./i8-slug/light/96.png": 2443,
	"./i8-snail/dark/24.png": 2444,
	"./i8-snail/dark/48.png": 2445,
	"./i8-snail/dark/480.png": 2446,
	"./i8-snail/dark/96.png": 2447,
	"./i8-snail/light/24.png": 2448,
	"./i8-snail/light/48.png": 2449,
	"./i8-snail/light/480.png": 2450,
	"./i8-snail/light/96.png": 2451,
	"./i8-spade/dark/24.png": 2452,
	"./i8-spade/dark/48.png": 2453,
	"./i8-spade/dark/480.png": 2454,
	"./i8-spade/dark/96.png": 2455,
	"./i8-spade/light/24.png": 2456,
	"./i8-spade/light/48.png": 2457,
	"./i8-spade/light/480.png": 2458,
	"./i8-spade/light/96.png": 2459,
	"./i8-spring/dark/24.png": 2460,
	"./i8-spring/dark/48.png": 2461,
	"./i8-spring/dark/480.png": 2462,
	"./i8-spring/dark/96.png": 2463,
	"./i8-spring/light/24.png": 2464,
	"./i8-spring/light/48.png": 2465,
	"./i8-spring/light/480.png": 2466,
	"./i8-spring/light/96.png": 2467,
	"./i8-sprout/dark/24.png": 2468,
	"./i8-sprout/dark/48.png": 2469,
	"./i8-sprout/dark/480.png": 2470,
	"./i8-sprout/dark/96.png": 2471,
	"./i8-sprout/light/24.png": 2472,
	"./i8-sprout/light/48.png": 2473,
	"./i8-sprout/light/480.png": 2474,
	"./i8-sprout/light/96.png": 2475,
	"./i8-stanley-knife/dark/24.png": 2476,
	"./i8-stanley-knife/dark/48.png": 2477,
	"./i8-stanley-knife/dark/480.png": 2478,
	"./i8-stanley-knife/dark/96.png": 2479,
	"./i8-stanley-knife/light/24.png": 2480,
	"./i8-stanley-knife/light/48.png": 2481,
	"./i8-stanley-knife/light/480.png": 2482,
	"./i8-stanley-knife/light/96.png": 2483,
	"./i8-stones/dark/24.png": 2484,
	"./i8-stones/dark/48.png": 2485,
	"./i8-stones/dark/480.png": 2486,
	"./i8-stones/dark/96.png": 2487,
	"./i8-stones/light/24.png": 2488,
	"./i8-stones/light/48.png": 2489,
	"./i8-stones/light/480.png": 2490,
	"./i8-stones/light/96.png": 2491,
	"./i8-strawberry/dark/24.png": 2492,
	"./i8-strawberry/dark/48.png": 2493,
	"./i8-strawberry/dark/480.png": 2494,
	"./i8-strawberry/dark/96.png": 2495,
	"./i8-strawberry/light/24.png": 2496,
	"./i8-strawberry/light/48.png": 2497,
	"./i8-strawberry/light/480.png": 2498,
	"./i8-strawberry/light/96.png": 2499,
	"./i8-toilet-bowl/dark/24.png": 2500,
	"./i8-toilet-bowl/dark/48.png": 2501,
	"./i8-toilet-bowl/dark/480.png": 2502,
	"./i8-toilet-bowl/dark/96.png": 2503,
	"./i8-toilet-bowl/light/24.png": 2504,
	"./i8-toilet-bowl/light/48.png": 2505,
	"./i8-toilet-bowl/light/480.png": 2506,
	"./i8-toilet-bowl/light/96.png": 2507,
	"./i8-tree-planting/dark/24.png": 2508,
	"./i8-tree-planting/dark/48.png": 2509,
	"./i8-tree-planting/dark/480.png": 2510,
	"./i8-tree-planting/dark/96.png": 2511,
	"./i8-tree-planting/light/24.png": 2512,
	"./i8-tree-planting/light/48.png": 2513,
	"./i8-tree-planting/light/480.png": 2514,
	"./i8-tree-planting/light/96.png": 2515,
	"./i8-treehouse/dark/24.png": 2516,
	"./i8-treehouse/dark/48.png": 2517,
	"./i8-treehouse/dark/480.png": 2518,
	"./i8-treehouse/dark/96.png": 2519,
	"./i8-treehouse/light/24.png": 2520,
	"./i8-treehouse/light/48.png": 2521,
	"./i8-treehouse/light/480.png": 2522,
	"./i8-treehouse/light/96.png": 2523,
	"./i8-truck/dark/24.png": 2524,
	"./i8-truck/dark/48.png": 2525,
	"./i8-truck/dark/480.png": 2526,
	"./i8-truck/dark/96.png": 2527,
	"./i8-truck/light/24.png": 2528,
	"./i8-truck/light/48.png": 2529,
	"./i8-truck/light/480.png": 2530,
	"./i8-truck/light/96.png": 2531,
	"./i8-waggon-truck/dark/24.png": 2532,
	"./i8-waggon-truck/dark/48.png": 2533,
	"./i8-waggon-truck/dark/480.png": 2534,
	"./i8-waggon-truck/dark/96.png": 2535,
	"./i8-waggon-truck/light/24.png": 2536,
	"./i8-waggon-truck/light/48.png": 2537,
	"./i8-waggon-truck/light/480.png": 2538,
	"./i8-waggon-truck/light/96.png": 2539,
	"./i8-wardrobe/dark/24.png": 2540,
	"./i8-wardrobe/dark/48.png": 2541,
	"./i8-wardrobe/dark/480.png": 2542,
	"./i8-wardrobe/dark/96.png": 2543,
	"./i8-wardrobe/light/24.png": 2544,
	"./i8-wardrobe/light/48.png": 2545,
	"./i8-wardrobe/light/480.png": 2546,
	"./i8-wardrobe/light/96.png": 2547,
	"./i8-water-hose/dark/24.png": 2548,
	"./i8-water-hose/dark/48.png": 2549,
	"./i8-water-hose/dark/480.png": 2550,
	"./i8-water-hose/dark/96.png": 2551,
	"./i8-water-hose/light/24.png": 2552,
	"./i8-water-hose/light/48.png": 2553,
	"./i8-water-hose/light/480.png": 2554,
	"./i8-water-hose/light/96.png": 2555,
	"./i8-watering-can/dark/24.png": 2556,
	"./i8-watering-can/dark/48.png": 2557,
	"./i8-watering-can/dark/480.png": 2558,
	"./i8-watering-can/dark/96.png": 2559,
	"./i8-watering-can/light/24.png": 2560,
	"./i8-watering-can/light/48.png": 2561,
	"./i8-watering-can/light/480.png": 2562,
	"./i8-watering-can/light/96.png": 2563,
	"./i8-wheelbarrow/dark/24.png": 2564,
	"./i8-wheelbarrow/dark/48.png": 2565,
	"./i8-wheelbarrow/dark/480.png": 2566,
	"./i8-wheelbarrow/dark/96.png": 2567,
	"./i8-wheelbarrow/light/24.png": 2568,
	"./i8-wheelbarrow/light/48.png": 2569,
	"./i8-wheelbarrow/light/480.png": 2570,
	"./i8-wheelbarrow/light/96.png": 2571,
	"./i8-wood/dark/24.png": 2572,
	"./i8-wood/dark/48.png": 2573,
	"./i8-wood/dark/480.png": 2574,
	"./i8-wood/dark/96.png": 2575,
	"./i8-wood/light/24.png": 2576,
	"./i8-wood/light/48.png": 2577,
	"./i8-wood/light/480.png": 2578,
	"./i8-wood/light/96.png": 2579,
	"./i8-worker/dark/24.png": 2580,
	"./i8-worker/dark/48.png": 2581,
	"./i8-worker/dark/480.png": 2582,
	"./i8-worker/dark/96.png": 2583,
	"./i8-worker/light/24.png": 2584,
	"./i8-worker/light/48.png": 2585,
	"./i8-worker/light/480.png": 2586,
	"./i8-worker/light/96.png": 2587
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1861;


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img \.(png)$
// module id = 1861
// module chunks = 2